import React from 'react';
import { motion } from 'framer-motion';
import { Home, PenTool, Layout, Users } from 'lucide-react';

const services = [
    {
        icon: <Home size={32} />,
        title: "תכנון אדריכלי",
        description: "תכנון מקיף משלב הסקיצה ועד לביצוע, תוך ירידה לפרטים הקטנים ביותר."
    },
    {
        icon: <Layout size={32} />,
        title: "עיצוב פנים",
        description: "יצירת חללים הרמוניים המשלבים אסתטיקה ופונקציונליות בצורה מושלמת."
    },
    {
        icon: <PenTool size={32} />,
        title: "הלבשת הבית",
        description: "בחירת ריהוט, טקסטיל ואקססוריז להשלמת המראה והאווירה הרצויה."
    },
    {
        icon: <Users size={32} />,
        title: "ליווי אישי",
        description: "ליווי צמוד לאורך כל הפרויקט, מול ספקים ובעלי מקצוע."
    }
];

const Services = () => {
    return (
        <section id="services" className="section services-section bg-light">
            <div className="container">
                <h2 className="section-title">שירותים</h2>
                <div className="services-grid">
                    {services.map((service, index) => (
                        <motion.div
                            key={index}
                            className="service-card"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <div className="service-icon">{service.icon}</div>
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
